module.exports = __webpack_public_path__ + "img/26.fa511633.jpg";